<p>
  <slate-children [children]="children" [context]="childrenContext" [viewContext]="viewContext"></slate-children>
</p>
